// just a static asset for now
(function () {
  // Your base, I'm in it!
  var originalAddClassMethod = jQuery.fn.addClass;

  jQuery.fn.addClass = function () {
    // Execute the original method.
    var result = originalAddClassMethod.apply(this, arguments);
    // trigger a custom event
    jQuery(this).trigger("cssClassChanged");
    // return the original result
    return result;
  };
})();

// Set active/inactive for navigation item
$(".nav-link").bind("cssClassChanged", function (e) {
  $(".nav-item").each(function () {
    if ($(this).hasClass("active") === true) {
      $(this).removeClass("active");
    }
  });
  $(this).removeClass("active").parent().addClass("active");
});

// Update Resources dropdown & left menu based on users actions
$(function (e) {
  //add active class to side nav li and aria-current to a tag
  var file = location.pathname.split("/").pop(); // set `current` page
  if (file !== 'faq.html') {
    // Update Resouces menu dropdown on the top left
    var groupId = $("a[anchorid='" + file + "']").attr('group');
    if (groupId) { updateResourceMenu(groupId); }
    $("ul.sidenav-sublist").addClass("hide-sublist"); // hide all the sublist
    // Set selected child active
    $('li[id="' + file.replace('.html', '') + '"]').addClass("active");
    $('a[href="' + file + '"]').attr("aria-current", "page");
    // Set selected child's parent
    var parentId = $('li[id="' + file.replace('.html', '') + '"]').attr("parentid");
    updateHeadingSubgroup(parentId);
  } else {
    // Set getting-started in faq.html to be selected when faq.html lands
    setFAQCategories('getting-started');
  }
  
  function $controls(el) {
    return $("#" + el.getAttribute("aria-controls"));
  }
});

// On click on Menu group header
$("ul.sidenav li a").on("click", function () {
  var file = location.pathname.split("/").pop();

  if (file !== 'faq.html') {
    // Update Resouces menu dropdown on the top left
    var groupId = $("a[anchorid='" + file + "']").attr('group');
    if (groupId) { updateResourceMenu(groupId); }
    // Remove active class from previous selected child li element
    $("ul.sidenav-sublist li").removeClass("active");
    $("ul.sidenav-sublist").addClass("hide-sublist");
    // Set the current selected child li & a elements
    updateSidenavSublist(file);
    // Reset previous parent element and set the current selected child parent element
    var parentId = $('ul.sidenav-sublist li[id="' + file.replace('.html', '') + '"]').attr("parentid");
    updateHeadingSubgroup(parentId);
  } else {
    var faqSection = $(this).attr('anchorId');
    setFAQCategories(faqSection);
  }
});

// On click on Menu group items
$("ul.sidenav-sublist li a").on("click", function () {
  var file = location.pathname.split("/").pop();
  if (file !== 'faq.html') {
    // Update Resouces menu dropdown on the top left
    var groupId = $("a[anchorid='" + file + "']").attr('group');
    if (groupId) { updateResourceMenu(groupId); }
    $("ul.sidenav-sublist li").removeClass("active");
    updateSidenavSublist(file);
  } else {
    var faqSection = $(this).attr('anchorId');
    setFAQCategories(faqSection);
  }
});

// On click landing page shortcut
var file = location.pathname.split("/").pop();
$('a.dropdown-item[id="' + file + '"]').addClass("disabled");
var groupId = $('a[anchorid="' + file + "']").attr('group');
if (groupId) {
  $("a.dropdown-item[group='" + groupId + "']").addClass("disabled");
}

// On click Resource dropdown item
$(function () {
  $("a.dropdown-item").on("click", function () {
    var file = location.pathname.split("/").pop();
    $("a.dropdown-item").removeClass("disabled");
    $('a.dropdown-item[id="' + file + '"]').addClass("disabled");
    var groupId = $('a[anchorid="' + file + "']").attr('group');
    if (groupId) {
      $("a.dropdown-item[group='" + groupId + "']").addClass("disabled");
    }
  });
});

// Search feature on FAQs page in answers - search as types
$("#faqs-search").on("keyup", function() {
  var userInput = $(this).val().toLowerCase();
  if(userInput.length > 0) {
    searchFAQ(userInput);
    $("ul.sidenav-sublist li").removeClass("active");
  } else {
    clearSearch();
  }
});

// Clear search with x button
$(function (e) {
  $("#faqs-search").on('search', function (e) {
      var userInput = $(this).val();
      if(userInput.length == 0) {
        clearSearch();
      }
  });
});

// Disabled enter key on FAQs search event to avoid override clear search
$(document).keypress(
  function(event) {
    if (event.which == '13') {
      event.preventDefault();
    }
  }
)

// Scroll feature for FAQs
$(window).scroll(function() {
  var lastId;
  var menuItems = $('#faq').find('a');
  var scrollItems = menuItems.map(function() {
    if ($($(this).attr("href")).is(":visible")) {
      var item = $($(this).attr("href"));
      if (item.length) { return item; }
    }
  });
  // Get container scroll position
  var fromTop = $(this).scrollTop() + 115;
  
  // Get id of current scroll item
  var cur = scrollItems.map(function() {
    if ($(this).offset().top < fromTop) {
      return this;
    }
      
  });
  // Get the id of the current element
  cur = cur[cur.length - 1];
  var id = cur && cur.length ? cur[0].id : "getting-started";
  
  if (lastId !== id) {
      lastId = id;
      // Set/remove active class
      if (id == "getting-started" && $("h2#getting-started").is(":visible")) {
        menuItems
        .parent().removeClass("active")
        .end().filter("[href='#" + id + "']").parent().addClass("active");
      } else if (id !== "getting-started" && $("h2#" + id).is(":visible")) {
        menuItems
        .parent().removeClass("active")
        .end().filter("[href='#" + id + "']").parent().addClass("active");
      }
  }                   
});

// Update Resources dropdown
function updateResourceMenu(groupId) {
  $("a.dropdown-item").removeClass("disabled");
  $("a.dropdown-item[group='" + groupId + "']").addClass("disabled");
}

// Update left menu group heading
function updateHeadingSubgroup(parentId) {
  $('ul.sidenav-sublist[id="' + parentId + '"]').removeClass("hide-sublist");
  $("ul.sidenav li a").removeClass("font-weight-bold");
  $('ul.sidenav li[id="' + parentId + '"] a[id="' + parentId + '"]').addClass("font-weight-bold");
}

// Update left menu group item
function updateSidenavSublist(file) {
  $('ul.sidenav-sublist li[id="' + file.replace('.html', '') + '"]').addClass("active");
  $('ul.sidenav-sublist li a[href="' + file + '"]').attr("aria-current", "page");
}

// Set FAQ categories active/inactive
function setFAQCategories(faqSection) {
  $("ul.sidenav-sublist li").removeClass("active");
  $('ul.sidenav-sublist li[id="section-' + faqSection.replace('#', '') + '"]').addClass("active");
  $('ul.sidenav-sublist li a[href="' + faqSection + '"]').attr("aria-current", "page");
}

// Clear search on FAQs
function clearSearch() {
  $("h2.heading-border").each(function () {
    $(this).show();
  });
  $("div.accordion div.card div.card-body").each(function() {
    $(this).parent().parent().show();
  });
  setFAQCategories('getting-started');
}

// Custom search feature for FAQs
function searchFAQ(userInput) {
  $("div.accordion div.card div.card-body").each(function() {
    var searchArea = $(this).text().toLowerCase();
    if (searchArea.indexOf(userInput) != -1) {
      $(this).parent().parent().show();
    } else {
      var question = $(this).parent().text().toLowerCase();
      if (question.indexOf(userInput) != -1) {
        $(this).parent().parent().show();
      } else {
        $(this).parent().parent().hide();
      }
    }
  });
  $("h2.heading-border").each(function () {
    var headingId = $(this).attr("id");
    if ($("div.accordion[data-faq-topic=" + headingId + "] div.card:visible").length == 0) {
      $("h2#" + headingId +".heading-border").hide();
    } else {
      $("h2#" + headingId +".heading-border").show();
    }
  });
}
